import { coreApi } from 'services/api'

interface IStudentProps {
  _id: string
  name: string
}

interface ICourseProps {
  _id: string
  name: string
}

export const DASHBOARD_PREFERENCE = async (
  localSelectedHours: number,
  student: IStudentProps,
  course: ICourseProps
) => {
  try {
    coreApi.post('/students/dashboard/preference', {
      hoursGoal: localSelectedHours,
      studentId: student._id,
      studentName: student.name,
      courseId: course._id,
      courseName: course.name,
    }),
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
  } catch (err) {
    console.log(err)
    throw err
  }
}
